import { FilterFilled } from "@ant-design/icons";
import { Input, Space } from "antd";
import _ from "lodash";
import React from "react";
import { TableName } from "../../components/ProgressTables/types";
import { MappingStateSelector } from "../../components/Selectors/MappingStateSelector/MappingStateSelector";
import { Filter } from "./types";
type Props = {
  onChange: (filter: Filter) => any;
  placeholder: string;
  tableName: TableName;
};

export const ComponentFilter = (props: Props) => (
  <Space>
    <FilterFilled />
    <Input
      placeholder={props.placeholder}
      onChange={_.debounce(
        (e) => props.onChange({ name: e.target.value }),
        300,
      )}
      allowClear
    />
    {props.tableName === "mappings" && (
      <MappingStateSelector
        onChange={(v) => props.onChange({ mappingState: v })}
      />
    )}
  </Space>
);
